import React, { useState, useEffect } from 'react';
import { authFetch } from '../utils/authFetch';
import { BASE_URL } from '../utils/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import villaImage from '../images/Container.svg';
import apartmentImage from '../images/sponer.svg';
import chaletImage from '../images/Tooltip.png';
import deleteIcon from '../images/trash-xmark.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NewOffersSwiper from "../components/NewOffersSwiper";

import styles from './BookmarksPage.module.css';

const BookmarksPage = () => {
    const { t } = useTranslation();
    const [bookmarks, setBookmarks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [demands, setDemands] = useState([]);
      const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const fetchDemands = async () => {
          try {
            const response = await authFetch(`${BASE_URL}/property/latest/demands?limit=30`);
            if (!response.ok) {
              throw new Error('Failed to fetch demands');
            }
    
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
              const data = await response.json();
              setDemands(data);
            } else {
              const text = await response.text();
              throw new Error(`Server returned a non-JSON response. Check your API route. Response was: "${text.substring(0, 50)}..."`);
            }
          } catch (err) {
            setError(err.message);
            console.error("Error fetching demands:", err);
          } finally {
            setIsLoading(false);
          }
        };
    
        fetchDemands();
    
        // const intervalId = setInterval(fetchDemands, 60000);
    
        return () => {
      // Polling disabled to prevent property changes during animation
          // clearInterval(intervalId);
        };
      }, []);

    useEffect(() => {
        const fetchBookmarks = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await authFetch(`${BASE_URL}/bookmark/bookmarks`);
                const result = await response.json();

                if (response.ok && result.data) {
                    const validBookmarks = result.data.filter(
                        bookmark => bookmark.Property && bookmark.Property.PropertyAddresses && bookmark.Property.PropertyAddresses.length > 0
                    );
                    setBookmarks(validBookmarks);
                } else {
                    setError(result.message || t('error_fetching_bookmarks_generic'));
                    toast.error(result.message || t('error_fetching_bookmarks_generic'));
                }
            } catch (err) {
                console.error("Error fetching bookmarks:", err);
                setError(t('error_fetching_bookmarks_network'));
                toast.error(t('error_fetching_bookmarks_network'));
            } finally {
                setLoading(false);
            }
        };

        fetchBookmarks();
    }, [t]);

    const handleUnbookmark = async (event, propertyIdToRemove) => {
        event.stopPropagation();
        try {
            const response = await authFetch(`${BASE_URL}/bookmark/bookmarks/${propertyIdToRemove}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                toast.success(t('bookmark_unbookmarked_success'));
                setBookmarks(prevBookmarks =>
                    prevBookmarks.filter(bookmark => bookmark.propertyId !== propertyIdToRemove)
                );
            } else {
                const errorData = await response.json();
                toast.error(errorData.message || t('bookmark_unbookmark_failed'));
            }
        } catch (error) {
            console.error("Error unbookmarking:", error);
            toast.error(t('bookmark_unbookmark_network_error'));
        }
    };

    const handleRowClick = (propertyId) => {
        navigate(`/EditOrView/${propertyId}`, { state: { fromBookmarksPage: true } });
    };

    if (loading) {
        return <div className={styles.loadingMessage}>{t('loading')} {t('Bookmark')}...</div>;
    }

    if (error) {
        return <div className={styles.errorMessage}>{t('error')}: {error}</div>;
    }
  return (
    <div className={styles.container}>
        <ToastContainer />
        <div className={styles.leftPanel}>
          
          <div className={styles.newSearchesHeader}>
            <h2 className={styles.newSearchesTitle}>{t("new_demands")}</h2>
          </div>
        <div className={styles.trendingCardsCarouselWrapper}>
        {isLoading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>Error: {error}</p>
        ) : demands.length > 0 ? (
          <NewOffersSwiper items={demands} className={styles.mySwiper} />
        ) : null}
        </div>
      </div>

            <div className={styles.rightPanel}>
                <h2 className={styles.pageHeader}> {t('Bookmark')}</h2>

                {bookmarks.length === 0 ? (
                    <div className={styles.emptyState}>{t('empty_bookmarks_state')}</div>
                ) : (
                    <div className={styles.tableContainer}>
                        <table className={styles.searchTable}>
                            <thead>
                                <tr>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('zip')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('city')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('Type')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('Sqm')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('Bedrooms')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('Units')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('Index')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}>{t('price')}</th>
                                    <th className={styles.tableHeader} style={{ textAlign: 'center' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookmarks.map((bookmark, index) => {
                                    const property = bookmark.Property;
                                    const address = property.PropertyAddresses[0];
                                    const rowClass = index % 2 === 0 ? styles.dataRowEven : styles.dataRowOdd;

                                    return (
                                        <tr
                                            key={bookmark.propertyId}
                                            className={`${styles.tableRow} ${rowClass}`}
                                            onClick={() => handleRowClick(bookmark.propertyId)}
                                        >
                                            <td className={`${styles.tableCell} ${styles.firstCell}`} style={{ textAlign: 'center' }}>
                                                {address?.zipCode || 'N/A'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {address?.city || 'N/A'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.propertyType?.toUpperCase() || 'N/A'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.squareMeters || 'N/A'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.propertyType !== 'multifamily' && property.propertyType !== 'plot'
                                                    ? (property.bedrooms || '-')
                                                    : '-'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.propertyType === 'multifamily'
                                                    ? (property.units || '-')
                                                    : '-'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.propertyType === 'plot'
                                                    ? (property.index || '-')
                                                    : '-'}
                                            </td>
                                            <td className={styles.tableCell} style={{ textAlign: 'center' }}>
                                                {property.price ? `${property.price / 1000} K` : 'N/A'}
                                            </td>
                                            <td className={`${styles.tableCell} ${styles.actionCell}`}>
                                                <button
                                                    className={styles.iconButton}
                                                    onClick={(e) => handleUnbookmark(e, bookmark.propertyId)}
                                                    title={t('unbookmark_title')}
                                                >
                                                    <img src={deleteIcon} alt={t('delete')} className={styles.iconImage} />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BookmarksPage;